export default __webpack_public_path__ + "static/media/connect.a642f0c1.png";